module.exports = __webpack_public_path__ + "img/wudata.0eb61efd.svg";